<template>
  <v-menu
    v-model="menuSettings"
    menu-props="offsetY"
    :nudge-bottom="45"
    max-width="600"
    min-width="600"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on: menu }">
      <ToolbarIconButton
        :tooltip="'Настройка'"
        :icon="'build'"
        :is-flat="flatSettingsButton"
        :btn-color="colorSettingsButton"
        :icon-color="iconColorSettingsButton"
        :is-top-position="isTopPositionSettingsButton"
        data-test="settingsButton"
        v-on="{ ...menu }"
      />
    </template>
    <v-card>
      <v-card-title class="py-0">
        <v-layout column>
          <h2 class="title mt-3">
            Настройка колонок
          </h2>
          <v-flex>
            <v-layout row>
              <v-select
                v-model="selected"
                :items="savedSettings"
                label="Сохранённые настройки"
                hide-details
                item-text="title"
                item-value="id"
                return-object
                menu-props="offsetY"
                outline
                clearable
                no-data-text="Нет данных"
                @click:clear="clearSelected"
                @input="getSetting"
              >
                <template v-slot:selection="data">
                  <span :selected="data.selected">
                    {{ data.item.title }}
                  </span>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-tile-content v-text="data.item.title" />
                  </template>
                </template>
              </v-select>
              <v-menu
                v-model="menuSave"
                :close-on-content-click="false"
                :nudge-width="200"
                menu-props="offsetY"
              >
                <v-btn
                  slot="activator"
                  icon
                  small
                  class="mb-0 mt-3"
                >
                  <v-icon color="grey darken-1">
                    save
                  </v-icon>
                </v-btn>
                <v-card>
                  <v-card-text>
                    <v-text-field
                      v-model="settingTitle"
                      :required="true"
                      :rules="[
                        v => !!v || 'Наименование обязательно к заполнению'
                      ]"
                      label="Наименование настройки"
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      small
                      flat
                      color="primary"
                      :disabled="!settingTitle"
                      @click="saveSetting"
                    >
                      Сохранить
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
              <v-btn
                v-if="selected"
                icon
                small
                class="mb-0 mt-3 ml-0"
                @click="deleteSetting(selected)"
              >
                <v-icon color="grey darken-1">
                  delete
                </v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex xs6>
            <h3 class="subheading grey--text text--darken-1">
              Отображаемые
            </h3>
            <div class="list">
              <v-list
                v-for="(item, index) in selectedColumns"
                :key="index"
                class="py-0"
              >
                <v-list-tile
                  class="list-title"
                  :style="{
                    cursor: item.type === 'group' ? 'default' : 'pointer'
                  }"
                >
                  <v-list-tile-content>
                    <v-list-tile-title
                      @click="moveColumn(item)"
                      v-text="item.title"
                    />
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-layout>
                      <v-btn
                        flat
                        small
                        icon
                        class="mx-1"
                        :disabled="index === 0 || item.type === 'group'"
                        @click="moveColumnUp(item)"
                      >
                        <v-icon small>
                          keyboard_arrow_up
                        </v-icon>
                      </v-btn>
                      <v-btn
                        flat
                        small
                        icon
                        class="mx-1"
                        :disabled="
                          index === selectedColumns.length - 1 ||
                            item.type === 'group'
                        "
                        @click="moveColumnDown(item)"
                      >
                        <v-icon small>
                          keyboard_arrow_down
                        </v-icon>
                      </v-btn>
                    </v-layout>
                  </v-list-tile-action>
                </v-list-tile>

                <v-list-tile
                  v-for="subItem in item.children"
                  :key="subItem.title"
                  class="list-title"
                  color="grey darken-2"
                >
                  <v-list-tile-content>
                    <v-list-tile-title
                      class="pl-3"
                      @click="moveColumn(item, subItem)"
                      v-text="subItem.title"
                    />
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-layout>
                      <v-btn
                        flat
                        small
                        icon
                        class="mx-1"
                        :disabled="index === 0"
                        @click="moveColumnUp(item, subItem)"
                      >
                        <v-icon
                          small
                          color="grey darken-2"
                        >
                          keyboard_arrow_up
                        </v-icon>
                      </v-btn>
                      <v-btn
                        flat
                        small
                        icon
                        class="mx-1"
                        :disabled="index === item.children.length - 1"
                        @click="moveColumnDown(item, subItem)"
                      >
                        <v-icon
                          small
                          color="grey darken-2"
                        >
                          keyboard_arrow_down
                        </v-icon>
                      </v-btn>
                    </v-layout>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </div>
          </v-flex>
          <v-divider
            vertical
            class="mx-1"
          />
          <v-flex xs6>
            <h3 class="subheading grey--text text--darken-1">
              Скрытые
            </h3>
            <div class="list">
              <v-list
                v-for="(item, index) in availableColumns"
                :key="index"
                class="py-0"
              >
                <v-list-tile @click="moveColumn(item)">
                  <v-list-tile-content>
                    <v-list-tile-title v-text="item.title" />
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  v-for="subItem in item.children"
                  :key="subItem.title"
                  color="grey darken-2"
                  @click="moveColumn(item, subItem)"
                >
                  <v-list-tile-content>
                    <v-list-tile-title
                      class="pl-3"
                      v-text="subItem.title"
                    />
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <SaveBtn @click="applyColumnSettings(columnsSettings)" />
        <CancelBtn @click="closeMenu" />
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
import arrayMove from "array-move";
import * as dataListApi from "../../backend/dataListApi.js";
import ToolbarIconButton from "../ToolbarIconButton.vue";
export default {
  components: {
    ToolbarIconButton,
  },
  props: [
    "columns",
    "resource",
    "groupTitle",
    "flatSettingsButton",
    "colorSettingsButton",
    "iconColorSettingsButton",
    "isTopPositionSettingsButton",
  ],
  data() {
    return {
      menuSettings: false,
      menuSave: false,
      settingTitle: "",
      columnsSettings: [],
      selected: null,
    };
  },
  computed: {
    availableColumns() {
      if (!this.columnsSettings.length) {
        return;
      }
      return this.columnsSettings.filter(c => !c.visible && c.type !== "icon");
    },
    selectedColumns() {
      if (!this.columnsSettings.length) {
        return;
      }
      this.columnsSettings.forEach(item => {
        if (item.type === "group") {
          item.title = this.groupTitle;
        }
      });
      return this.columnsSettings.filter(c => c.visible && c.type !== "icon");
    },
    storeSelected() {
      return this.$store.getters[`${this.resource}/selectedSetting`];
    },
    storeColumns() {
      return this.$store.getters[`${this.resource}/columns`];
    },
    savedSettings: {
      get() {
        return this.$store.getters[`${this.resource}/savedSettings`];
      },
      set(savedSettings) {
        this.$store.commit(`${this.resource}/setSavedSettings`, savedSettings);
      },
    },
  },
  watch: {
    menuSave(value) {
      if (value && this.selected) {
        this.settingTitle = this.selected.title;
      } else {
        this.settingTitle = "";
      }
    },
  },
  created() {
    this.columnsSettings = JSON.parse(JSON.stringify(this.columns));
    this.getData();
  },
  methods: {
    async getData() {
      this.savedSettings = await dataListApi.getColumnSettings(this.resource);
      if (this.storeColumns.length) {
        this.selected = this.storeSelected;
        this.applyColumnSettings(this.storeColumns);
      } else if (this.savedSettings.length) {
        this.selected = this.savedSettings[0];
        this.$store.commit(`${this.resource}/setSelectedSetting`, {
          ...this.savedSettings[0],
        });
        this.applyColumnSettings(JSON.parse(this.savedSettings[0].settings));
      } else {
        this.applyColumnSettings(this.columns);
      }
    },
    applyColumnSettings(settings) {
      if (!settings.length) {
        return;
      }
      const columnsItems = JSON.parse(JSON.stringify(this.columns));
      columnsItems.forEach(c => {
        const column = settings.find(s => s.name == c.name);
        if (column) {
          c.order = column.order;
          c.visible = column.visible;
        }
        if (column && column.children) {
          c.children.forEach(ch => {
            const subColumn = column.children.find(i => i.name === ch.name);
            if (subColumn) {
              ch.visible = subColumn.visible;
              ch.order = subColumn.order;
            }
          });
        }
      });
      const newColumns = this.selected
        ? this.initOrderForNewColumns(columnsItems, settings)
        : columnsItems;

      this.columnsSettings = newColumns.sort((a, b) => {
        let aOrder = 0;
        if (Object.prototype.hasOwnProperty.call(a, "order")) {
          aOrder = a.order;
        } else {
          aOrder = this.headers.indexOf(a);
        }
        let bOrder = 0;
        if (Object.prototype.hasOwnProperty.call(b, "order")) {
          bOrder = b.order;
        } else {
          bOrder = this.headers.indexOf(b);
        }
        if (aOrder < bOrder) {
          return -1;
        }
        if (aOrder > bOrder) {
          return 1;
        }
        return 0;
      });
      this.$store.commit(
        `${this.resource}/setColumns`,
        JSON.parse(JSON.stringify(newColumns)),
      );
      if (!this.selected) {
        this.$store.commit(`${this.resource}/setSelectedSetting`, null);
      }
      this.menuSettings = false;
    },
    async getSetting(setting) {
      if (!setting) {
        return;
      }
      const res = await dataListApi.getSettings(setting.id);
      this.$store.commit(`${this.resource}/setSelectedSetting`, {
        id: res.data.Id,
        title: res.data.Title,
        settings: res.data.Settings,
      });
      this.applyColumnSettings(JSON.parse(res.data.Settings));
      this.changeDateSettings(setting);
    },
    async changeDateSettings(setting) {
      if (setting) {
        await dataListApi.changeDateSettings(setting.id);
      }
    },
    async saveSetting() {
      const setting = {
        resource: this.resource,
        title: this.settingTitle,
        settings: JSON.stringify(this.columnsSettings),
      };
      if (this.selected) {
        this.savedSettings = await dataListApi.updateColumnSettings(
          this.selected.id,
          setting,
        );
        this.selected = this.savedSettings.find(s => s.id === this.selected.id);
        this.$store.commit(`${this.resource}/setSelectedSetting`, {
          ...this.selected,
        });
        this.menuSave = false;
      } else {
        this.savedSettings = await dataListApi.createColumnSettings(setting);
        this.selected = this.savedSettings.find(s => s.title === setting.title);
        this.$store.commit(`${this.resource}/setSelectedSetting`, {
          ...this.selected,
        });
        this.settingTitle = "";
        this.menuSave = false;
      }
      this.menuSettings = false;
      this.applyColumnSettings(this.columnsSettings);
    },
    async deleteSetting(setting) {
      if (confirm("Удалить настройку?")) {
        await dataListApi.deleteSetting(setting.id);
        this.selected = null;
        this.$store.commit(`${this.resource}/setSelectedSetting`, null);
        this.$store.commit(
          `${this.resource}/setColumns`,
          JSON.parse(JSON.stringify(this.columns)),
        );
        this.clearSelected();
        this.savedSettings = await dataListApi.getColumnSettings(this.resource);
        this.showInfo("Настройка удалена");
      }
    },
    moveColumn(item, subItem) {
      if (!item || item.type === "group") {
        return;
      }

      this.columnsSettings.forEach(c => {
        if (c.name === item.name) {
          c.visible = !item.visible;
          c.order = item.order;
          c.children = item.children;
        }
        if (subItem) {
          this.columnsSettings
            .find(c => c.name === item.name)
            .children.forEach(i => {
              if (i.name === subItem.name) {
                c.visible = !subItem.visible;
                c.order = subItem.order;
              }
            });
        }
      });
    },
    moveColumnUp(item, subItem) {
      if (subItem) {
        let settingsItems = this.columnsSettings.find(c => c.name === item.name)
          .children;
        const selectedColsItems = this.selectedColumns.find(
          c => c.name === item.name,
        ).children;
        const settingsIndex = settingsItems.indexOf(
          settingsItems.find(i => i.name === subItem.name),
        );
        const selectedColsIndex = selectedColsItems.indexOf(
          selectedColsItems.find(c => c.name === item.name),
        );
        const order = this.selectedColsItems[selectedColsIndex + 1]?.order;
        settingsItems = arrayMove(
          settingsItems,
          settingsIndex,
          selectedColsIndex - 1 > -1
            ? order
              ? order
              : selectedColsIndex - 1
            : 0,
        );

        settingsItems.forEach((item, index) => (item.order = index));
        this.columnsSettings.find(
          c => c.name === item.name,
        ).children = settingsItems;
      } else {
        const settingsIndex = this.columnsSettings.indexOf(
          this.columnsSettings.find(c => c.name === item.name),
        );
        const selectedColsIndex = this.selectedColumns.indexOf(
          this.selectedColumns.find(c => c.name === item.name),
        );
        const order = this.selectedColumns[selectedColsIndex - 1]?.order;
        this.columnsSettings = arrayMove(
          this.columnsSettings,
          settingsIndex,
          selectedColsIndex - 1 > -1
            ? order
              ? order
              : selectedColsIndex - 1
            : 0,
        );
        this.columnsSettings.forEach((c, index) => {
          c.order = index;
        });
      }
    },
    moveColumnDown(item, subItem) {
      if (subItem) {
        let settingsItems = this.columnsSettings.find(c => c.name === item.name)
          .children;
        const selectedColsItems = this.selectedColumns.find(
          c => c.name === item.name,
        ).children;
        const settingsIndex = settingsItems.indexOf(
          settingsItems.find(i => i.name === subItem.name),
        );
        const selectedColsIndex = selectedColsItems.indexOf(
          selectedColsItems.find(c => c.name === item.name),
        );
        const order = this.selectedColsItems[selectedColsIndex + 1]?.order;
        settingsItems = arrayMove(
          settingsItems,
          settingsIndex,
          order ? order : selectedColsIndex + 1,
        );

        settingsItems.forEach((item, index) => (item.order = index));
        this.columnsSettings.find(
          c => c.name === item.name,
        ).children = settingsItems;
      } else {
        const settingsIndex = this.columnsSettings.indexOf(
          this.columnsSettings.find(c => c.name === item.name),
        );
        const selectedColsIndex = this.selectedColumns.indexOf(
          this.selectedColumns.find(c => c.name === item.name),
        );
        const order = this.selectedColumns[selectedColsIndex + 1]?.order;
        this.columnsSettings = arrayMove(
          this.columnsSettings,
          settingsIndex,
          order ? order : selectedColsIndex + 1,
        );
        this.columnsSettings.forEach((c, index) => {
          c.order = index;
        });
      }
    },
    clearSelected() {
      this.columnsSettings = JSON.parse(JSON.stringify(this.columns));
    },
    closeMenu() {
      this.menuSettings = false;
      this.selected = { ...this.storeSelected };
      this.applyColumnSettings(this.storeColumns);
    },
    initOrderForNewColumns(items, settings) {
      const itemsWithOrderZero = items.filter(i => i.order === 0);
      const matching = settings.find(
        s => s.name === itemsWithOrderZero.find(i => i.name)?.name,
      );
      const filteringItems = itemsWithOrderZero.filter(
        i => i.name !== matching?.name,
      );
      let maxOrder = Math.max(...items.map(i => i.order));
      items.forEach(i => {
        const column = filteringItems.find(s => s.name == i.name);
        if (column) {
          i.order = maxOrder++;
        }
      });
      return items;
    },
  },
};
</script>
